import { createSlice } from '@reduxjs/toolkit';
import { createTemplate, getTemplateDetails, getTemplates, updateTemplateName, updateTemplateItems, getTemplateById } from '.';

const initialState = {
	loading: false,
	list: [],
	details: null,
	total: 0,
};

const templates = createSlice({
	name: 'templates',
	initialState,
	reducers: {
		resetTemplates: () => initialState,
		setTemplatesDetails: (state, action) => {
			state.details = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(getTemplates.pending, (state) => {
				state.loading = true;
			})
			.addCase(getTemplates.fulfilled, (state, action) => {
				state.loading = false;
				const { data, total } = action.payload.response.data.data;
				state.list = data;
				state.total = total;
			})
			.addCase(getTemplates.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(createTemplate.pending, (state) => {
				state.loading = true;
			})
			.addCase(createTemplate.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(createTemplate.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getTemplateDetails.pending, (state) => {
				state.loading = true;
			})
			.addCase(getTemplateDetails.fulfilled, (state, action) => {
				state.loading = false;
				state.details = action.payload.response.data.data;
			})
			.addCase(getTemplateDetails.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getTemplateById.pending, (state) => {
				state.loading = true;
			})
			.addCase(getTemplateById.fulfilled, (state, action) => {
				state.loading = false;
				state.details = action.payload.response.data.data;
			})
			.addCase(getTemplateById.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(updateTemplateName.pending, (state) => {
				state.loading = true;
			})
			.addCase(updateTemplateName.fulfilled, (state) => {
				state.loading = false;
				state.details = null;
			})
			.addCase(updateTemplateName.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(updateTemplateItems.pending, (state) => {
				state.loading = true;
			})
			.addCase(updateTemplateItems.fulfilled, (state) => {
				state.loading = false;
				state.details = null;
			})
			.addCase(updateTemplateItems.rejected, (state) => {
				state.loading = false;
			});
	}
});

export const { resetTemplates, setTemplatesDetails } = templates.actions;

export default templates.reducer;